import React, { useEffect, useState } from "react";
import AOS from "aos";

import "./SmartCities.css";
import "aos/dist/aos.css";

const SmartCities = () => {
  const [rtl, setRtl] = useState(localStorage.getItem("Language") == "rtl");
  const [fr, setFr] = useState(localStorage.getItem("Language") == "fr");

  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    var rtl = document.querySelector("body").getAttribute("class");
    // rtl ? (rtl.includes("rtl") ? setRtl(true) : setRtl(false)) : null;
    if (rtl) {
      if (rtl.includes("rtl")) {
        setRtl(true);
      } else {
        setRtl(false);
      }
    }
  }, []);
  return (
    <>
      <div>
        <div class="wrapper" id="cover">
          <img
            src={require("../../Assets/images/Smart-Cities-cover.webp")}
            class="prx"
            style={{ height: "205px", width: "100%" }}
          />
          <h1>
            {rtl
              ? `المدن الذكية`
              : fr
              ? `Villes Intelligentes`
              : `Smart Cities`}
          </h1>
        </div>
      </div>

      <section class="section innerpage bg">
        <div class="smart-cities-content">
          <div class="row m-0 smart-cities">
            <div class="smart-cities-w">
              <h3 class="title c-4 ff-regular">
                {rtl
                  ? `المدن الذكية ومنطقة التجارة الحرة`
                  : fr
                  ? `VILLES INTELLIGENTES ET ZONE DE LIBRE-ÉCHANGE`
                  : `SMART CITIES & FREE TRADING ZONE`}
              </h3>
              <span class="border"></span>
              <br />
              <div class="content">
                <h3
                  class="title c-4 ff-regular"
                  style={{
                    color: "#d8a419",
                    marginBottom: "20px",
                  }}
                  id="smartCities"
                >
                  {rtl
                    ? `المدن الذكية`
                    : fr
                    ? `Villes Intelligentes`
                    : `SMART CITIES`}
                </h3>
                <p>
                  <span
                    class="title c-4"
                    style={{
                      float: "none",
                      fontSize: "25px",
                    }}
                  >
                    {" "}
                  </span>{" "}
                  {rtl
                    ? `تمكن المدن الذكية المستدامة من التقدم عندما يتم توجيه دمج التكنولوجيا إلى نهج استراتيجي للتنمية المستدامة ولكي تزدهر المدن الذكية ، نحتاج إلى إنشاء نماذج تجارية مستدامة تسهل نجاح جميع الجهات الفاعلة في النظام الإيكولوجي
ويجب أن تكون البرمجيات منسوجة في نسيج حلول إنترنت الأشياء بحيث يستفيد جميع المساهمين في النظم الإيكولوجية؛ وهذا يشمل مصنعي المعدات الأصلية والمطورين والمتكاملين والحكومات ، ويجب تقييم الملكية الفكرية لكل عضو ومكافأتها. تمكن قدرات برامج الاشتراك نماذج أعمال جديدة تسمح لكل مساهم باستخراج القيمة من مساهمته في النظام البيئي.
`
                    : fr
                    ? `Les villes durables et intelligentes permettent le progrès lorsque l'intégration de la technologie
                    est orientée vers une approche stratégique du développement durable. Pour que les villes
                    intelligentes prospèrent, nous devons établir des modèles commerciaux durables qui facilitent le
                    succès de tous les acteurs de l'écosystème. Le logiciel doit être tissé dans le tissu des solutions IoT
                    afin que tous les contributeurs de l'écosystème en bénéficient ; cela inclut les OEM, les
                    développeurs, les intégrateurs, les gouvernements, la propriété intellectuelle de chaque membre
                    doit être valorisée et récompensée. Les capacités du logiciel d'abonnement permettent de
                    nouveaux modèles commerciaux qui permettent à chaque contributeur d'extraire de la valeur de
                    sa contribution à l'écosystème.`
                    : `Sustainable,smart cities enable progress
                                    when the integration of technology is
                                    directed into a strategic approach to
                                    sustainable development and For smart cities
                                    to thrive, we need to establish sustainable
                                    commerce models that facilitate the success
                                    of all ecosystem players. The software must
                                    be woven into the fabric of IoT solutions so
                                    that all ecosystem contributors benefit;
                                    this includes OEMs, developers, integrators,
                                    governments, Each member’s intellectual
                                    property needs to be valued and
                                    rewarded.Subscription software capabilities
                                    enable new business models that allow each
                                    contributor to extract value from their
                                    contribution to the ecosystem.`}
                </p>
                <p>
                  <span
                    class="title c-4"
                    style={{
                      float: "none",
                      fontSize: "25px",
                    }}
                  ></span>
                  {rtl
                    ? `توفر النماذج القائمة على الاشتراك طريقة لتحقيق الدخل من الأجهزة والبرامج المستخدمة لبناء البنى التحتية الذكية وتوزيع النفقات بعيدا عن الإنفاق الرأسمالي الضخم لمرة واحدة. على سبيل المثال ، يمكن بيع المعدات الطبية باهظة الثمن مثل ماسحات التصوير بالرنين المغناطيسي على أساس التكلفة لكل مسح ضوئي بدلا من كتكلفة مقدمة لمرة واحدة للمستشفيات.
وهذا يخلق وضعا مربحا للجانبين للمستشفيات والموردين على حد سواء. وفي يوم من الأيام القريبة، ستقدم المدن اشتراكات بأسعار معقولة لأساطيل المركبات المشتركة بين المالكين الذين قد يختارون من بين مجموعة من الخيارات المخصصة. يمكن أن تقلل هذه الخطوة بشكل جذري من حركة المرور وتحسين أنماط حركة المرور ومشاركة الركوب.`
                    : fr
                    ? `Les modèles d'abonnement offrent un moyen de monétiser le matériel et les logiciels utilisés
                    pour construire des infrastructures intelligentes et de répartir les dépenses en s'éloignant d'un
                    énorme investissement ponctuel. Les équipements médicaux coûteux comme les scanners IRM,
                    par exemple, peuvent être vendus au coût par scan plutôt que comme une dépense initiale
                    unique pour les hôpitaux. Et un jour prochain, les villes proposeront des abonnements abordables
                    à des flottes de véhicules partagées entre des propriétaires qui pourront choisir parmi toute une
                    série d'options personnalisées. Cette évolution pourrait réduire radicalement le trafic et
                    optimiser la circulation et le covoiturage.`
                    : `Subscription-based models offer a way to
                                    monetize hardware and software used to build
                                    smart infrastructures and spread out
                                    expenses moving away from a huge one time
                                    CAPEX spend. Expensive medical equipment
                                    like MRI scanners, for example, can be sold
                                    at a cost-per-scan basis rather than as a
                                    one-time upfront expense for hospitals. This
                                    creates a win-win situation for hospitals
                                    and suppliers alike.And one day soon, cities
                                    will offer affordable subscriptions to
                                    fleets of vehicles shared between owners who
                                    may choose from an array of custom options.
                                    This move could radically reduce traffic and
                                    optimize traffic patterns and ride-sharing.`}
                </p>
                <p>
                  <span
                    class="title c-4"
                    style={{
                      float: "none",
                      fontSize: "25px",
                    }}
                  ></span>
                  {rtl
                    ? `مع استمرار المناطق الحضرية في التوسع والنمو ، تتطور تكنولوجيا المدن الذكية جنبا إلى جنب لتعزيز الاستدامة وخدمة البشرية بشكل أفضل. من خلال الاستفادة من الاتصال المنتشر والبيانات المفتوحة والأمن الشامل وحلول تحقيق الدخل من البرامج ، يمكننا مواءمة احتياجات المدن الذكية المتطورة للحصول على تجربة محسنة بكثير لجميع الشركاء في النظام البيئي.`
                    : fr
                    ? `Alors que les zones urbaines continuent de s'étendre et de croître, la technologie des villes
                    intelligentes se développe parallèlement pour améliorer la durabilité et mieux servir
                    l'humanité. En tirant parti de la connectivité omniprésente, de l'ouverture des données, de
                    la sécurité de bout en bout et des solutions de monétisation des logiciels, nous pouvons
                    aligner les besoins évolutifs des villes intelligentes pour une expérience nettement
                    améliorée pour tous les partenaires de l'écosystème.`
                    : `As urban areas continue to expand and grow,
                                    smart city technology is developing
                                    alongside to enhance sustainability and
                                    better serve humanity. By leveraging
                                    pervasive connectivity, open data,
                                    end-to-end security, and software
                                    monetization solutions, we can align
                                    evolving smart city needs for a
                                    much-improved experience for all partners in
                                    the ecosystem.`}
                </p>

                <span class="smart-cities-goal">
                  {rtl
                    ? `هدفنا هو تحقيق مدن ذكية مستدامة مع استراتيجيات تركز على الاتصال والذكاء والأمن`
                    : fr
                    ? `NOTRE OBJECTIF EST DE CRÉER DES VILLES DURABLES ET INTELLIGENTES GRÂCE À
                    DES STRATÉGIES AXÉES SUR LA CONNECTIVITÉ, L'INTELLIGENCE ET LA SÉCURITÉ.`
                    : `Our goal is to achieve sustainable, smart
                                    cities with strategies that focus on
                                    connectivity, intelligence, and security`}
                </span>

                <div class="inline-block">
                  <div class="cities-block" data-aos="fade-up">
                    <h3>{rtl ? `الخصوصيه` : fr ? `VIE PRIVÉE` : `Privacy`}</h3>
                    <p>
                      {rtl
                        ? `المخاوف والخوف من الخروقات الأمنية فاقت بكثير القيمة المتصورة لمشاركة المعلومات`
                        : fr
                        ? `Les préoccupations en matière de
                        protection de la vie privée et la
                        crainte des failles de sécurité ont
                        largement dépassé la valeur perçue
                        du partage des informations.`
                        : `concerns and fear of security
                                            breaches have far outweighed the
                                            perceived value of sharing
                                            information.`}
                    </p>
                  </div>
                  <div
                    class="cities-block"
                    data-aos="fade-up"
                    data-aos-delay="100"
                  >
                    <h3>{rtl ? `خيري` : fr ? `Charité` : `Charity`}</h3>
                    <p>
                      {rtl
                        ? `أحد العوامل التمكينية الرئيسية للمدن الذكية المستدامة هو أن جميع المشاركين في النظام البيئي المعقد`
                        : fr
                        ? `L'un des facteurs clés des villes
                        intelligentes durables est que tous
                        les participants de l'écosystème
                        complexe doivent être en mesure
                        d'apporter leur contribution.`
                        : `a key enabler of sustainable smart
                                            cities is that all participants in
                                            the complex ecosystem`}
                    </p>
                  </div>
                  <div
                    class="cities-block"
                    data-aos="fade-up"
                    data-aos-delay="200"
                  >
                    <h3>
                      {rtl
                        ? `التعاون القطاعي`
                        : fr
                        ? `Coopération sectorielle`
                        : `Sectors Cooperation`}
                    </h3>
                    <p>
                      {rtl
                        ? `لتحقيق نتائج أفضل ومستدامة من خلال تحليل المعلومات السياقية في الوقت الحقيقي`
                        : fr
                        ? `Pour obtenir des résultats
                        meilleurs et durables grâce
                        à l'analyse d'informations
                        contextuelles en temps réel`
                        : `to achieve better, sustainable
                                            outcomes through the analysis of
                                            real-time contextual information`}
                    </p>
                  </div>
                </div>

                <h3
                  class="title c-4 ff-regular"
                  style={{
                    color: "#d8a419",
                    marginBottom: "20px",
                  }}
                  id="tradingZone"
                >
                  {rtl
                    ? `منطقة التجارة الحرة`
                    : fr
                    ? `ZONE D'ÉCHANGE LIBRE`
                    : `FREE TRADING ZONE`}
                </h3>
                <p>
                  {rtl
                    ? `وسيتولى المكتب التجاري للطاقة إدارة مخزونات النفط والغاز الطبيعي ونواتج التقطير والفحم. ومن المتوقع أن يكون جزء كبير من التداول داخل القارة بسبب الاحتياجات المحلية على الرغم من أنه سيكون هناك أسواق دولية نشطة، وكذلك`
                    : fr
                    ? `Le bureau de négociation pour l'énergie gérera les stocks de pétrole, de gaz
                    naturel, de distillats de carburant et de charbon. Il est prévu qu'une grande
                    partie du commerce se fera à l'intérieur du continent en raison des besoins
                    locaux, mais il y aura également des marchés internationaux actifs.`
                    : `The trading desk for energy will manage
                                    inventories of Petroleum, Natural Gas, Fuel
                                    Distillates and Coal. It is anticipated that
                                    much of the trading will be
                                    intra-continental due to local needs
                                    although there will active international
                                    markets, as well.`}
                  <br />{" "}
                  {rtl
                    ? `وصف أكثر تفصيلا لقطاع الطاقة الذي سيشارك فيه بنك الاستثمار الإسلامي مفصل في مكان آخر على هذا الموقع وعلى موقعنا الإلكتروني المرتبط به ،
MMH & ABS المجموعة الهندسية
 www.mmhabs.com
`
                    : fr
                    ? `Une description plus détaillée du secteur de l'énergie dans lequel The Islamic
                    Investment Bank sera impliquée est présentée ailleurs sur ce site Web et sur
                    notre site Web associé, MMH&ABS Engineering Group www.mmhabs.com.`
                    : `A more detailed description of the
                                    Energy sector in which The Islamic
                                    investment Bank will be involved is detailed
                                    elsewhere on this website and on our
                                    associated website, MMH&ABS Engineering
                                    Group www.mmhabs.com.`}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SmartCities;
